/* eslint-disable react/prop-types, complexity */
import React from 'react';

import { Col, Row, Spin } from 'antd';
import cn from 'classnames';

import GanttVisualization from '#components/GanttVisualization';
import useWindowDimensions from '#hooks/useWindowDimensions.js';
import ActivityTreePane from '#components/ActivityTreePane/ActivityTreePane.jsx';
import { isFeatureOn } from '#utils/featureUtils.js';

export function GanttView({
  activeActivityTreePane,
  activitiesTreePanel,
  antIcon,
  currentActivityHidden,
  defaultView,
  filterSettings,
  getLookahead,
  isLoading,
  isReloadDataViews,
  propsTimelineView,
  setActiveActivityTreePane,
  setActivityTreePaneSettings,
  t
}) {
  const { height } = useWindowDimensions();

  return (
    <Row>
      <Col
        style={{ height: height - 222 }}
        className={cn({
          'activity-pane__container':
            isFeatureOn('enable-LWP-103') &&
            activeActivityTreePane &&
            !isLoading
        })}>
        {isFeatureOn('enable-LWP-103') &&
          activeActivityTreePane &&
          !isLoading && (
            <ActivityTreePane
              activities={activitiesTreePanel}
              actitySettings={defaultView.current.activityTreeSettings}
              closePane={setActiveActivityTreePane}
              filterSettings={filterSettings}
              onCommandDispach={getLookahead}
              viewId={defaultView.current.id}
              setActivityTreePaneSettings={setActivityTreePaneSettings}
              isReloadDataViews={isReloadDataViews}
              t={t}
              currentActivityHidden={currentActivityHidden}
            />
          )}
        {isReloadDataViews && (
          <div>
            <Spin
              className="loader-spinner-lookahead-table"
              indicator={antIcon}
            />
          </div>
        )}

        {!isReloadDataViews && <GanttVisualization {...propsTimelineView} />}
      </Col>
    </Row>
  );
}
